import Raven from 'raven-js';
import { Component } from 'react';
import CrmLocationErrorMessage from './CrmLocationErrorMessage';
import { Metrics } from './Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
export default class CrmLocationErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      error: undefined
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error(error);
    Metrics.counter('location-error', Object.assign({
      location: this.props.location,
      source: this.props.source,
      errorType: 'unknown'
    }, this.props.loggingTag ? {
      logging_tag: this.props.loggingTag
    } : {})).increment();
    Raven.captureException(error, {
      extra: {
        location: this.props.location,
        source: this.props.source,
        loggingTag: this.props.loggingTag,
        errorInfo
      }
    });
  }
  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    return /*#__PURE__*/_jsx(CrmLocationErrorMessage, {});
  }
}